import { LAYOUT_MODE_TYPES, LAYOUT_TOPBAR_THEME_TYPES, LEFT_SIDEBAR_COLOR_TYPES } from '../Common/constants/layout';

const THEME_STORAGE_KEY = 'dashboard-theme-mode';

export interface ThemePreference {
  layoutMode: LAYOUT_MODE_TYPES.LIGHTMODE | LAYOUT_MODE_TYPES.DARKMODE;
  topbarColor: LAYOUT_TOPBAR_THEME_TYPES;
  sidebarColor: LEFT_SIDEBAR_COLOR_TYPES;
}

export const saveThemePreference = (themePreference: ThemePreference): void => {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, JSON.stringify(themePreference));
  } catch (error) {
    console.warn('Failed to save theme preference to localStorage:', error);
  }
};

export const loadThemePreference = (): ThemePreference | null => {
  try {
    const saved = localStorage.getItem(THEME_STORAGE_KEY);
    if (saved) {
      return JSON.parse(saved);
    }
  } catch (error) {
    console.warn('Failed to load theme preference from localStorage:', error);
  }
  return null;
};

export const clearThemePreference = (): void => {
  try {
    localStorage.removeItem(THEME_STORAGE_KEY);
  } catch (error) {
    console.warn('Failed to clear theme preference from localStorage:', error);
  }
};

export const getDefaultThemePreference = (): ThemePreference => {
  return {
    layoutMode: LAYOUT_MODE_TYPES.LIGHTMODE,
    topbarColor: LAYOUT_TOPBAR_THEME_TYPES.LIGHT,
    sidebarColor: LEFT_SIDEBAR_COLOR_TYPES.LIGHT,
  };
};
